import React from 'react';
import { STEPS, LINKS } from '../data/mock';

export default function TheRitual() {
  return (
    <section id="l8" className="chapter" style={{ flexDirection: 'column' }}>
      <div style={{ maxWidth: 1200, width: '100%', margin: '0 auto' }}>
        <div className="chapter-eyebrow font-sans">LIFE VIII · THE RITUAL</div>
        <p className="big-prose" style={{ marginBottom: 60 }}>
          Three steps.<br />
          Five minutes. <em><i>No permission.</i></em>
        </p>
        <div className="steps">
          {STEPS.map((s) => (
            <div className="step-card" key={s.id}>
              <div className="step-id font-sans">STEP {s.id}</div>
              <div className="step-title">{s.title}</div>
              <p className="step-body font-sans">{s.body}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 60, padding: 30, border: '1px solid rgba(243,192,74,0.2)', borderRadius: 8, background: 'rgba(15,16,23,0.5)', maxWidth: 780, margin: '60px auto 0', textAlign: 'center' }}>
          <p style={{ color: '#f2ead5', fontFamily: "'Cormorant Garamond', serif", fontSize: 22, marginBottom: 8, fontStyle: 'italic' }}>Never done any of this before?</p>
          <p style={{ color: 'rgba(242,234,213,0.65)', fontSize: 14, letterSpacing: '0.05em' }}>
            Start at <a href={LINKS.academy} style={{ color: '#f3c04a', textDecoration: 'underline', textUnderlineOffset: 4 }}>FISHE Academy</a> — short lessons on crypto, wallets and staying safe. No wallet needed.
          </p>
        </div>
      </div>
    </section>
  );
}
